export const LOGIN_ANNOUNCEMENT_PROMPT_KEY = "euas:login-announcements:pending";
export const LOGIN_ANNOUNCEMENT_CHECKED_KEY = "euas:login-announcements:checked";

/**
 * Bu sekmede kullanıcıya zaten gösterilmiş popup duyuruların id'leri.
 *
 * Gösterim "oturumda bir kez" yerine "duyuru başına bir kez" olarak
 * kısıtlanıyor: yönetici oturum açıkken popup yayınladığında kullanıcının
 * çıkış yapıp yeniden girmesi gerekmesin, ama her F5'te aynı duyuru tekrar
 * tekrar önüne çıkmasın.
 */
export const LOGIN_ANNOUNCEMENT_SHOWN_IDS_KEY = "euas:login-announcements:shown";

export function markLoginAnnouncementsPending(): void {
  window.sessionStorage.setItem(LOGIN_ANNOUNCEMENT_PROMPT_KEY, "1");
  window.sessionStorage.removeItem(LOGIN_ANNOUNCEMENT_CHECKED_KEY);
  // Yeni giriş yapan başka bir kullanıcı olabilir; "gösterildi" listesi sıfırlanır.
  window.sessionStorage.removeItem(LOGIN_ANNOUNCEMENT_SHOWN_IDS_KEY);
}

export function getShownLoginAnnouncementIds(): Set<string> {
  try {
    const raw = window.sessionStorage.getItem(LOGIN_ANNOUNCEMENT_SHOWN_IDS_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === "string") : []);
  } catch {
    return new Set();
  }
}

export function markLoginAnnouncementsShown(ids: string[]): void {
  if (ids.length === 0) return;
  const merged = getShownLoginAnnouncementIds();
  ids.forEach((id) => merged.add(id));
  try {
    window.sessionStorage.setItem(
      LOGIN_ANNOUNCEMENT_SHOWN_IDS_KEY,
      JSON.stringify([...merged]),
    );
  } catch {
    // Kota dolu / storage kapalı: gösterim tekrar edebilir, akış bozulmaz.
  }
}
